import { api, storage } from '../services';

function retry(retried) {
  if (!retried) {
    window.location.href = `${window.location.pathname}${window.location.search}&retried=true`;
  }
  return { success: false };
}

async function savePermissions(params) {
  const savedLead = storage.getLead();
  const resultAuthorizeApp = await api.authorizeApp(params.code);
  if (!resultAuthorizeApp.ok) {
    const { data } = resultAuthorizeApp;
    if (
      data.errors &&
      Array.isArray(data.errors) &&
      data.errors[0].code === 'E10005'
    ) {
      return { success: false, returnToAlreadyExists: true };
    }
    return retry(params.retried);
  }

  const resultSavePermissions = await api.savePermissions(params.state);
  if (!resultSavePermissions.ok) {
    return retry(params.retried);
  }

  if (savedLead.email !== params.state) {
    storage.removeLead();
    return { success: false, returnToActivate: true };
  }

  return { success: true };
}

export default savePermissions;
